import { Text, View } from '@components/primitives';
import colors from '@theme/colors';
import { SentryHelper } from '@utils/performance/SentryHelper';
import secureStore from '@utils/secureStore';
import tokenManager from '@utils/secureStore/tokenManager';
import { goBackToHome, serverError } from '@utils/utils';
import React from 'react';
import { logLoginSuccssfull, logOTPFailed, logOtpConfirm } from './analyticOTP';
import styles from './styles';

export async function showErrors(
  isError: boolean,
  error: string[],
  setIsOTPLoading: (v: boolean) => void,
  setErrTxtMsg: (v: string) => void,
  t: any,
  mobileNumber: string,
  isOTPConfirm: boolean,
  setDisableOTP: null | ((v: boolean) => void) = null,
): Promise<void> {
  if (isError && error) {
    if (isOTPConfirm) {
      logOtpConfirm(mobileNumber, error, t);
    } else {
      logOTPFailed(mobileNumber, error);
    }
    setIsOTPLoading(false);
    if (setDisableOTP) {
      setDisableOTP(true);
    }
    setErrTxtMsg(t(`errorCodes.${error[0]}`));
  }
}

export async function storeTokensFromOTPData(
  isSuccess: boolean,
  otpData: any,
  setOtpData: (data: any) => void,
): Promise<void> {
  const data = { ...otpData };
  if (isSuccess && data) {
    await secureStore.setItemAsync('accessToken', data.accessToken);
    await secureStore.setItemAsync('refreshToken', data.refreshToken);
    tokenManager.setAccessToken(data.accessToken);
    tokenManager.setRefreshToken(data.refreshToken);
  }
  delete data.accessToken;
  delete data.refreshToken;
  setOtpData(data);
}

export function getDisabledOTPStyles(disableOTP: boolean): object {
  return disableOTP ? styles.otpDisabled : {};
}

export function getErrorOTPStyles(errTxtMsg: string): object {
  return errTxtMsg.length > 0 ? styles.otpFailed : {};
}

export function handleOnCodeChanged(setOtp: (code: string) => void, setErrTxtMsg: (msg: string) => void) {
  return (code: string) => {
    setOtp(code);
    setErrTxtMsg('');
  };
}

export function shouldShowErrorMessage(sErrorMessage: string): JSX.Element | null {
  if (sErrorMessage && sErrorMessage.length > 0) {
    return (
      <View style={styles.errorStyles}>
        <Text
          testID="txtErrorToastMsg"
          alignSelf="center"
          textAlign="center"
          color={colors.error.rose}
          variant="sm-normal">
          {sErrorMessage}
        </Text>
      </View>
    );
  }
  return null;
}

export function shouldShowErrorOnOTP(
  isMeError: boolean,
  errorMe: any,
  toast: any,
  t: any,
  navigation: any,
  setInitialData: (data: any) => void,
): void {
  if (isMeError && errorMe) {
    serverError(errorMe, toast, t, navigation, setInitialData);
  }
}

interface MeApiData {
  accounts: any[];
  canShowReferral: boolean;
  employeeId: string;
  isInLockPeriod: boolean;
  referralApplicable: boolean;
  status: string;
  userId: string;
  employerId: string;
  firstName: string;
  lastName: string;
}

interface SuccessOTPProps {
  meApiData: MeApiData;
  isSuccessMe: boolean;
  setAccounts: (v: any[]) => void;
  setSelectedAccount: (v: any) => void;
  setCanShowReferral: (v: boolean) => void;
  setEmployeeId: (v: string) => void;
  setIsInLockPeriod: (v: boolean) => void;
  setReferralApplicable: (v: boolean) => void;
  setStatus: (v: string) => void;
  setUserId: (v: string) => void;
  setEmployerId: (v: string) => void;
  navigation: any;
}

export function shouldNavigateToHomeOnSuccess(props: SuccessOTPProps): void {
  const {
    meApiData,
    isSuccessMe,
    setAccounts,
    setSelectedAccount,
    setCanShowReferral,
    setEmployeeId,
    setIsInLockPeriod,
    setReferralApplicable,
    setStatus,
    setUserId,
    setEmployerId,
    navigation,
  } = props;
  if (meApiData && isSuccessMe) {
    const {
      accounts,
      canShowReferral,
      employeeId,
      isInLockPeriod,
      referralApplicable,
      status,
      userId,
      employerId,
      firstName,
      lastName,
    } = meApiData;
    setAccounts(accounts);
    setSelectedAccount({ ...accounts.filter(item => item.isWithdrawalEligible)[0] });
    setCanShowReferral(canShowReferral);
    setEmployeeId(employeeId);
    setIsInLockPeriod(isInLockPeriod);
    setReferralApplicable(referralApplicable);
    setStatus(status);
    setUserId(userId);
    setEmployerId(employerId);
    SentryHelper.setUser(employeeId, employerId, `${firstName} ${lastName}`);
    navigation.navigate('Home');
  }
}

interface OTPParams {
  isSuccess: boolean;
  otpData: any;
  setOtp: (v: string) => void;
  setOtpData: (data: any) => void;
  navigation: any;
  mobileNumber: string;
}

export function shouldStoreTokensOnSuccessOTP(params: OTPParams): void {
  const { isSuccess, otpData, setOtp, setOtpData, navigation, mobileNumber } = params;
  if (isSuccess && otpData) {
    setOtp('');
    (async () => {
      await storeTokensFromOTPData(isSuccess, otpData, setOtpData);
      logLoginSuccssfull(mobileNumber);
      goBackToHome(navigation, false);
    })();
  }
}
